module.exports = __webpack_public_path__ + "static/media/plantronics-backbeat-fit-2100.92182441.png";